import { useEffect, useState } from "react";
import { ApiCall, BindDropDownList, NotificationSound, currentDate, getBeforeDate, handleDateChange, handleDownloadExcel, setFocus } from "../../Common/Common";
import { AutoCompleteBoxNew, CustomButton, DateBox, InputBox, SelectInputBox } from "../../Common/Input";
import { NewTable } from "../../Common/NewTable";

const AcceptedUsers = () => {
    const [tableLoading, setTableLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ sortColumn: null, sortOrder: null });
    const [pageSize, setPageSize] = useState("10");
    const [filterData, setFilterData] = useState({
        type: "S",
        searchText: "",
        searchFieldValue: "",
        startValue: "",
        AdvanceFilter: []
    })
    const initialState = {
        DateFrom: getBeforeDate(7),
        DateTo: currentDate(),
        JobCode: '',
    }
    const [formData, setFormData] = useState(initialState);

    const handleChange1 = (event, pagenumber) => {
        setCurrentPageNo(pagenumber)
    }

    const ShowUserLogReport = async (formData) => {
        let request = {
            ...filterData,
            ...sortConfig,
            ...formData,
            pageSize: pageSize,
            pageIndex: `${currentPageNo}`,
            PageType: "AcceptedUsers"
        }
        setTableLoading(true)
        let response = await ApiCall(`/api/Report/JobDashboardReport`, { ...request })
        if (response.Status === 'SUCCESS') {
            setTableData(response);
            setTableLoading(false)
        } else if (response.Status === 'ERROR') {
            setTableData([]);
            setTableLoading(false)
        } else {
            setTableLoading(false)
            NotificationSound(response.Status, response.Message, response.focus)
        }
    }

    const handleReset = async () => {
        await setFormData(initialState)
        ShowUserLogReport(initialState)
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleDownLoadExcel = () => {
        let request = {
            ...sortConfig,
            ...formData,
            pageIndex: `${currentPageNo}`,
            pageSize: pageSize,
            Type: 'E',
            PageType: "AcceptedUsers",
            AdvanceFilter: [{
                "SearchingValue": filterData.SearchFieldValue,
                "ComparisonType": filterData.StartValue,
                "SearchingText": filterData.SearchText,
                "SearchingText1": '',
            }],
        }
        handleDownloadExcel('/api/Report/JobDashboardReport', 'Accepted Users', request)
    }

    //...........for DropDown Bind..............
    let { data: Status } = BindDropDownList('StatusMaster', 'Status', 'StatusCode', "Order by Status")

    useEffect(() => {
        document.title = 'Accepted Users'
        setFocus('txtDateFrom')
        ShowUserLogReport(formData)
    }, [currentPageNo, sortConfig, pageSize])

    return (
        <>
            <div className="my-5 rounded-xl border bg-white p-3">
                <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
                    <DateBox
                        id='txtDateFrom'
                        label='Date From'
                        placeholder='Date From'
                        selected={formData.DateFrom === '' ? '' : new Date(formData.DateFrom)}
                        onChange={(e) => handleDateChange(e, setFormData, formData, 'DateFrom')}
                        autoComplete="off"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtDateTo')
                            }
                        }}
                    />
                    <DateBox
                        id='txtDateTo'
                        label='Date To'
                        placeholder='Date To'
                        selected={formData.DateTo === '' ? '' : new Date(formData.DateTo)}
                        onChange={(e) => handleDateChange(e, setFormData, formData, 'DateTo')}
                        autoComplete="off"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtJobCode')
                            }
                        }}
                    />
                    <AutoCompleteBoxNew
                        id='txtJobCode'
                        label='Job Code'
                        placeholder='Job Code'
                        autocompleteType='GetJobCode'
                        value={formData?.jobCode || ''}
                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || '';
                            setFormData((prevData) => ({
                                ...prevData,
                                jobCode: newInputValue
                            }))
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('btn_Save');
                            }
                        }}
                    />
                </div>
                <div className="mt-3 flex items-center gap-3">
                    <CustomButton
                        label='Search'
                        id={'btn_Save'}
                        color={'yellow'}
                        onClick={(e) => ShowUserLogReport(formData)}
                    />
                    <CustomButton
                        label='Reset'
                        id={'btn_Reset'}
                        color={'red'}
                        onClick={async () =>
                            handleReset()

                        }
                    />
                </div>
            </div>
            <NewTable
                tableLoading={tableLoading}
                PageName={'AcceptedUsers'}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                handleFilter={() => {
                    setFilterData({
                        ...filterData,
                    })
                }}
                pageSize={pageSize}
                setPageSize={setPageSize}
                Filter={false}
                exportExcelData={true}
                handleDownLoadExcel={handleDownLoadExcel}
            />
        </>
    )
}

export default AcceptedUsers